/**
 * Base URL (origin) para success_url / cancel_url / return_url enviados à API.
 * O @IsUrl() do backend tende a rejeitar hostname `localhost` (sem TLD);
 * `127.0.0.1` costuma ser aceito para o mesmo serviço em dev.
 *
 * @see UserClubs — mesmo critério aplicado ao join de clube.
 */
function getCheckoutRedirectOrigin(): string {
	const envUrl = import.meta.env.VITE_FRONTEND_URL as string | undefined;
	if (envUrl) {
		return envUrl.replace(/\/+$/, '');
	}
	const base = typeof window !== 'undefined' ? window.location.origin : '';
	return base.replace(/\/+$/, '');
}

export function buildCheckoutRedirectUrl(path: string): string {
	const origin = getCheckoutRedirectOrigin();
	const p = path.startsWith('/') ? path : `/${path}`;
	return `${origin}${p}`;
}

export function buildCurrentLocationCheckoutUrl(): string {
	if (typeof window === 'undefined') return '';
	const origin = getCheckoutRedirectOrigin();
	const { pathname, search, hash } = window.location;
	return `${origin}${pathname}${search}${hash}`;
}
